export default __webpack_public_path__ + "static/lovdata-pro-2-boks-e83af417ae6b23c5458ad27b1b049510.svg";